module.exports = __webpack_public_path__ + "media/images/uncdfc-f2e5017db6e9a395a42ae613a2fb952a.png";